import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './HorseMoreInfo.module.scss';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import React from 'react';
import IconBox from '../../IconBox/IconBox';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import AdaIcon from '../../AdaIcon';
const HorseMoreInfo = ({ data }) => {
    const { t } = useTranslation();
    const dailyRaceBlocks = (desc) => {
        const numbers = desc.split('/').map(Number);
        return (_jsx("div", Object.assign({ className: styles.blocks }, { children: Array.from(Array(numbers[1]).keys()).map((blockId) => (_jsx("div", { className: blockId < numbers[0] ? styles.blocks__active : '' }, blockId))) })));
    };
    const makeElement = ({ title, icon, desc, iconComponent }) => (_jsxs("div", Object.assign({ "data-testid": "horseMoreInfo", className: cn(styles.box, 'd-flex') }, { children: [_jsx(IconBox, Object.assign({ className: styles.icon, type: 2 }, { children: !iconComponent ? _jsx("img", { src: icon, alt: '' }) : _jsx(AdaIcon, {}) })), _jsxs("div", Object.assign({ className: cn(styles.wrapper, 'd-flex flex-column') }, { children: [_jsx(Paragraph, { title: title, size: 1, color: 'grey' }), _jsx("p", { children: desc }), title === t('daily_race') && dailyRaceBlocks(desc)] }))] }), title));
    return _jsx("div", Object.assign({ className: styles.element }, { children: data.map(makeElement) }));
};
export default HorseMoreInfo;
